// extracted by mini-css-extract-plugin
export var details = "_hf-0";
export var inspectorPopover = "_hf-1";